<script lang="ts">
  import { Router, Route } from "svelte-routing";
  import Credits from "./pages/Credits.svelte";
  import Game from "./pages/Game.svelte";
  import Homepage from "./pages/Homepage.svelte";
</script>

<Router>
  <div>
    <Route path="/" component={Homepage} />
    <Route path="/play" component={Game} />
    <Route path="/credits" component={Credits} />
  </div>
</Router>

<svelte:head>
  <title>Editor-in-Chief</title>
</svelte:head>